import { useEffect, useState } from "react";
import { ReconciliationStatus } from "../constants/ReconciliationStatus";
import { adjustReconciliation, fetchReconciliationHistory, getFileById, getReconciliationInfo, postReconciliationInfo } from "../services/AllServices";
import { blobUrlToDataUrl, downloadCSV, showMessage } from "../utils/helpers";

const useReconciliationViewController = () => {
    const [reconciliationStatus, setReconciliationStatus] = useState(null);
    const [message, setMessage] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [reconciliationFile, setReconciliationFile] = useState(null);
    const [error, setError] = useState(null);
    const [uploadFile, setUploadFile] = useState(null);
    const [enableUpload, setEnableUpload] = useState(false);
    const [reconciliationId, setReconciliationId] = useState(null);
    const [approvalStatus, setApprovalStatus] = useState(null);
    const [loading, setLoading] = useState(false);
    const [reconciliationHistory, setReconciliationHistory] = useState([]);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [fileName, setFileName] = useState("");


    useEffect(() => {
        fetchReconciliationStatus();
        getReconciliationHistory();
    }, []);

    useEffect(() => {

        if (reconciliationStatus === ReconciliationStatus.COMPUTING_DISCREPANCIES_FAILED) {
            setMessage("Computing Discrepancy failed. Please upload the file again");
        }
        else {
            setMessage(null);
        }


    }, [reconciliationStatus]);


    useEffect(() => {
        if (endDate && uploadFile) {
            setEnableUpload(true);
        } else {
            setEnableUpload(false);
        }
    }, [endDate, uploadFile]);


    const fetchReconciliationStatus = async () => {
        setLoading(true);
        setUploadFile(null);
        setFileName("");
        try {
            const responseData = await getReconciliationInfo();
            setStartDate(responseData?.data?.start_date);
            if (responseData?.data.file_id) {
                setReconciliationFile(responseData?.data.file_id);
            }
            if (responseData?.data.reconciliation_id) {
                setReconciliationId(responseData?.data.reconciliation_id);
            }
            if (responseData?.data.state) {
                const state = responseData?.data.state;
                switch (state) {
                    case "COMPUTING_DISCREPANCIES_FAILED":
                        setReconciliationStatus(ReconciliationStatus.COMPUTING_DISCREPANCIES_FAILED);
                        break;
                    case "RESOLVING_DISCREPANCIES_FAILED":
                        setReconciliationStatus(ReconciliationStatus.RESOLVING_DISCREPANCIES_FAILED);
                        break;
                    case "COMPUTING_DISCREPANCIES":
                        setReconciliationStatus(ReconciliationStatus.COMPUTING_DISCREPANCIES);
                        break;
                    case "RESOLVING_DISCREPANCIES":
                        setReconciliationStatus(ReconciliationStatus.RESOLVING_DISCREPANCIES);
                        break;
                    case "COMPUTING_DISCREPANCIES_SUCCESS":
                        setReconciliationStatus(ReconciliationStatus.COMPUTING_DISCREPANCIES_SUCCESS);
                        break;
                    case "RESOLVING_DISCREPANCIES_SUCCESS":
                        setReconciliationStatus(ReconciliationStatus.RESOLVING_DISCREPANCIES_SUCCESS);
                        break;
                    case "NO_DESCREPANCIES_FOUND":
                        setReconciliationStatus(ReconciliationStatus.NO_DESCREPANCIES_FOUND);
                        break;
                    default:
                        setReconciliationStatus(ReconciliationStatus.RESOLVING_DISCREPANCIES_SUCCESS);
                }
            }
        } catch (error) {
            setError(error?.response?.message || "Something went wrong");
        }
        setLoading(false);
    }


    const onContinue = async () => {
        setLoading(true);
        const formData = new FormData();
        formData.append("watson_sales_csv", uploadFile);
        formData.append("end_date", endDate);
        try {
            const responseData = await postReconciliationInfo(formData);
            if (responseData.data) {
                setEndDate(responseData.data.end_date);
                showMessage("success", responseData.message);
                fetchReconciliationStatus();
            } else {
                showMessage("error", responseData.message || "Something went wrong");
            }
        } catch (error) {
            console.error(error);
            showMessage("error", error.message || "Something went wrong");
        } finally {
            setEndDate(null);
            setUploadFile(null);
            setFileName("");
            setLoading(false);
        }
    }

    const onReload = async () => {
        window.location.reload();
        fetchReconciliationStatus();
    }
    const onApproveOrReject = async () => {
        setShowConfirmationModal(false);
        setLoading(true);
        try {
            const responseData = await adjustReconciliation(reconciliationId, approvalStatus);
            showMessage("success", responseData.message);
        }
        catch (error) {
            showMessage("error", error.message);
        }
        finally {
            setEndDate(null);
            setUploadFile(null);
            setFileName("");
            onReload();
            setLoading(false);
        }

    }

    const downloadSampleCSV = () => {
        downloadCSV(process.env.PUBLIC_URL + "/ReconciliationSample.csv","Reconciliation Sample.csv");
    };

    const downloadReconciliationfile = async (fileId) => {
        const responseData = await getFileById(fileId);
        blobUrlToDataUrl(responseData)

    }


    const getReconciliationHistory = async () => {
        setLoading(true);
        try {
            const responseData = await fetchReconciliationHistory();
            setReconciliationHistory(responseData?.data);

        }
        catch (error) {
            showMessage("error", error.message || "Something went wrong");
        }
        setLoading(false);
    }



    return {
        reconciliationStatus,
        message,
        startDate,
        endDate,
        setEndDate,
        reconciliationFile,
        error,
        setUploadFile,
        onContinue,
        enableUpload,
        onReload,
        onApproveOrReject,
        downloadReconciliationfile,
        loading,
        reconciliationHistory,
        setShowConfirmationModal,
        showConfirmationModal,
        setApprovalStatus,
        uploadFile,
        fileName,
        setFileName,
        downloadSampleCSV

    };
};

export default useReconciliationViewController;